import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzSliderModule } from '@blk/daisy/combinations/slider';
import { DataServiceModule } from '@ddt-web/data-service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ModelsSliderComponent } from './models-slider.component';

@NgModule({
	declarations: [ModelsSliderComponent],
	imports: [
		CommonModule,
		CwpNgFrameworkModule,
		DataServiceModule,
		DzSliderModule,
		FormsModule,
		NgxSkeletonLoaderModule
	],
	exports: [ModelsSliderComponent]
})
export class ModelsSliderModule { }
